import { FormProvider, useForm, useWatch } from 'react-hook-form';
import { BillCreateFormData } from '../../../../providers/TaskCreationProvider/TaskCreationProvider';
import { ESignatureConfirm } from '../../../../../components/ESignature/ESignatureConfirm';
import React from 'react';
import PageSelector from '../../../../../components/PageSelector/PageSelector';
import { useUserId } from '../../../../../hooks/useCurrentUser/useCurrentUser';
import { ESignature } from '../../../../../components/ESignature/ESignature';
import { Bill } from '../../../../../components/PayBill/PayBillCreateForm';
import { TaxBindingHeader } from './TaxBindingHeader';

export const TaxFill = ({
  onNext,
  nextButtonText,
  value,
  scannedTax,
  scanning,
  scanningSkipped,
  onSkipScanning,
  onBack,
  index,
  totalDocuments,
  skipDocumentAnalysisReset,
}: {
  onNext: (data: BillCreateFormData) => void;
  nextButtonText?: string;
  value: BillCreateFormData;
  scannedTax: Bill | null;
  scanning: boolean;
  scanningSkipped: boolean;
  onSkipScanning: (key: string) => void;
  onBack: () => void;
  index: number;
  totalDocuments: number;
  skipDocumentAnalysisReset: boolean;
}) => {
  const methods = useForm<BillCreateFormData>({
    defaultValues: value,
  });
  React.useEffect(() => {
    methods.reset({ ...value }, { keepValues: false });
  }, [value]);
  const [page, setPage] = React.useState<'fill' | 'sign'>('sign');
  const documents = value.documents;

  const documentUrl = documents?.[0]?.src;
  const ref = React.useRef(null);
  const userId = useUserId();
  const annotations = useWatch({
    control: methods.control,
    name: 'annotations',
  });

  return (
    <FormProvider {...methods}>
      <TaxBindingHeader
        entity={value.to}
        index={index}
        totalDocuments={totalDocuments}
      />
      <PageSelector current={page}>
        <PageSelector.Page value="fill">
          <ESignatureConfirm
            handleNext={async (data) => {
              onNext(data);
            }}
            nextButtonText={nextButtonText}
            taxScanned={scannedTax}
            taxScanning={scanning}
            scanningSkipped={scanningSkipped}
            onSkipScanning={() => onSkipScanning(documents?.[0]?.key ?? '')}
            skipDocumentAnalysisReset={skipDocumentAnalysisReset}
          />
        </PageSelector.Page>
        <PageSelector.Page value="sign">
          {documentUrl && (
            <ESignature
              ref={ref}
              documentUrl={documentUrl}
              userId={userId}
              annotations={annotations}
              handleNext={async () => {
                setPage('fill');
              }}
              onBack={onBack}
            />
          )}
        </PageSelector.Page>
      </PageSelector>
    </FormProvider>
  );
};
